module.exports = __webpack_public_path__ + "img/Ov04-AR2006-P005-0031.72feeee0.jpg";